<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<mat-card class="main-card">
	<mat-card-content class="card-content">
		<span class="page-title">Customer Details</span>

		<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" preserveContent class="order-tab-group">
			<!-- <mat-tab label="Customer Details"> -->
			<!-- <div class="tab-body"> -->
			<!-- <div *ngIf="basketCustomerId"> -->
			<!-- <customer-view [basketCustomerId]="basketCustomerId"></customer-view> -->
			<to-be-implemented></to-be-implemented>
			<!-- </div> -->
			<!-- </div> -->
			<!-- </mat-tab> -->

			<mat-tab label="Orders">
				<div class="tab-body">
					<div>
						<mat-card>
							<mat-card-content class="bottom-padding-0px">
								<list-filter title="Orders" [showFilters]="true" (filterChanged)="onFilterChanged($event)" (showFiltersChanged)="onShowFiltersChanged()">
									<order-search-list-filter class="filterContent" (isOrganiserUser)="setIsOrganiserUser($event)" [customerId]="customerId"></order-search-list-filter>
								</list-filter>
							</mat-card-content>
						</mat-card>
					</div>

					<div>
						<mat-card [ngClass]="{ 'customer-order-detail-collapsed': parentCollapsed, 'customer-order-detail-expanded': !parentCollapsed }">
							<mat-card-content>
								<order-search-list [isOrganiserUser]="isOrganiserUser" [customerId]="customerId"></order-search-list>
							</mat-card-content>
						</mat-card>
					</div>
				</div>
			</mat-tab>
			<!-- <mat-tab label="Membership Codes">
		<div class="tab-body">
			<to-be-implemented></to-be-implemented>
		</div>
	</mat-tab> -->
			<!-- <mat-tab label="Reservations">
		<div class="tab-body">
			<to-be-implemented></to-be-implemented>
		</div>
	</mat-tab> -->
		</mat-tab-group>
	</mat-card-content>
</mat-card>
